import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { withState, withHandlers } from 'recompose';
import { deleteEstimate } from 'state/estimates/actions';
import { Events, track, getEstimateData } from 'components/analytics';
import { AlertButton, CancelButton } from 'components/buttons';
import Modal from 'components/modal';
import SuccessModal from 'components/modals/success';
import SvgTrashIcon from 'icons/TrashIcon';
import { compose } from 'lodash/fp';
import SvgBackIcon from 'icons/BackIcon';

const EstimateDeletedModal = ({ close, ...props }) => {
  const header = (
    <>
      Ok, that’s done!
      <br />
      Your estimate has now been deleted
    </>
  );
  return <SuccessModal completed={true} header={header} {...props} onRequestClose={close} />;
};

const DeleteButton = ({
  handleDeleteEstimate,
  isModalOpen,
  isCancelled,
  onClick,
  cancel,
  closeSuccessModal,
}) => {
  const buttons = (
    <>
      <CancelButton onClick={cancel}>
        <SvgBackIcon className="icon" />
        Cancel
      </CancelButton>
      <AlertButton onClick={handleDeleteEstimate}>
        <SvgTrashIcon className="icon" data-test="deleteEstimateConfirm" />
        Delete
      </AlertButton>
    </>
  );
  return (
    <>
      <AlertButton className="delete" onClick={onClick} data-test="deleteEstimate">
        <SvgTrashIcon className="icon" />
        Delete
      </AlertButton>
      <Modal
        isOpen={isModalOpen && !isCancelled}
        title="Delete Estimate"
        onRequestClose={cancel}
        buttons={buttons}
      >
        Are you sure you want to delete this estimate?
      </Modal>
      <EstimateDeletedModal close={() => closeSuccessModal()} isOpen={isModalOpen && isCancelled} />
    </>
  );
};

const mapDispatchToProps = (dispatch, { estimate, setCancelled }) => ({
  handleDeleteEstimate: () => {
    dispatch(deleteEstimate(estimate.id));
    track(Events.ESTIMATE_DELETE_SUCCESS, getEstimateData(estimate));
    setCancelled(true);
  },
  closeSuccessModal: () => {
    dispatch(push('/campaigns'));
  },
});

export default compose(
  withState('isModalOpen', 'toggleModal', false),
  withState('isCancelled', 'setCancelled', false),
  withHandlers({
    onClick: ({ toggleModal, estimate }) => () => {
      toggleModal(true);
      track(Events.ESTIMATE_DELETE_CLICK, getEstimateData(estimate));
    },
    cancel: ({ toggleModal, estimate }) => () => {
      toggleModal(false);
      track(Events.ESTIMATE_DELETE_CANCEL, getEstimateData(estimate));
    },
  }),
  connect(null, mapDispatchToProps)
)(DeleteButton);
